import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  HYUNDAI_MENU_NGRX_FEATURE_KEY,
  HyundaiServicesState,
  hyundaiMenuAcceptedAdapter,
  hyundaiMenuDeclinedAdapter,
} from './hyundai-menu-ngrx.reducer';

// Lookup the 'HyundaiMenuNgrx' feature state managed by NgRx
export const getHyundaiMenuNgrxState = createFeatureSelector<HyundaiServicesState>(HYUNDAI_MENU_NGRX_FEATURE_KEY);

const { selectAll, selectEntities } = hyundaiMenuAcceptedAdapter.getSelectors();
//const approvedQuoteLines = createSelector(getServiceLaneState, (state: ServiceLaneState) => state.approvedQuoteLines);

export const getHyundaiServices = createSelector(getHyundaiMenuNgrxState, (state: HyundaiServicesState) => state);
export const getAcceptedServices = createSelector(
  getHyundaiMenuNgrxState,
  (state: HyundaiServicesState) => state.acceptedServices
);
export const getDeclinedServices = createSelector(
  getHyundaiMenuNgrxState,
  (state: HyundaiServicesState) => state.declinedServices
);

// export const getHyundaiMenuNgrxLoaded = createSelector(getHyundaiMenuNgrxState, (state: State) => state.loaded);

// export const getHyundaiMenuNgrxError = createSelector(getHyundaiMenuNgrxState, (state: State) => state.error);

// export const getAllHyundaiMenuNgrx = createSelector(getHyundaiMenuNgrxState, (state: State) => selectAll(state));

// export const getHyundaiMenuNgrxEntities = createSelector(getHyundaiMenuNgrxState, (state: State) =>
//   selectEntities(state)
// );

// export const getSelectedId = createSelector(getHyundaiMenuNgrxState, (state: State) => state.selectedId);

// export const getSelected = createSelector(getHyundaiMenuNgrxEntities, getSelectedId, (entities, selectedId) =>
//   selectedId ? entities[selectedId] : undefined
// );
